import toast from "react-hot-toast";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAgents } from "@/components/Agents/AgentsContext";

const PLANS = [
  { id: "standard", name: "Standard", blurb: "Unlimited agents. Credit pool. Overseer included." },
  { id: "plus", name: "Plus", blurb: "Unlimited agents. Larger credit pool. Overseer included." },
  { id: "premier", name: "Premier", blurb: "Unlimited agents. Largest credit pool. Overseer included." },
] as const;

export function CheckoutPage() {
  const { org, may, viewOnly } = useAgents();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Checkout</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Change plan or add-ons. Prices and payment provider are placeholders for Phase 1.
        </p>
      </div>

      {viewOnly ? (
        <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100">
          Standard role is view only. Super Admin completes checkout.
        </p>
      ) : null}

      <div className="grid gap-4 sm:grid-cols-3">
        {PLANS.map((plan) => {
          const current = org.plan === plan.id;
          return (
            <Card key={plan.id} className={current ? "ring-2 ring-gray-900 dark:ring-white" : ""}>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-base">
                  {plan.name}
                  {current ? <Badge>Current</Badge> : null}
                </CardTitle>
                <CardDescription>{plan.blurb}</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="mb-3 text-2xl font-semibold">TBD</p>
                <Button
                  type="button"
                  className="w-full"
                  variant={current ? "outline" : "default"}
                  disabled={!may("manage_billing") || current}
                  onClick={() =>
                    toast.success(`${plan.name} checkout is a stub until billing is wired.`)
                  }
                >
                  {current ? "Current plan" : `Choose ${plan.name}`}
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Add-ons</CardTitle>
          <CardDescription>Max multiplies the credit pool by 20</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-wrap gap-3">
          <Button
            type="button"
            variant="outline"
            disabled={!may("manage_billing")}
            onClick={() => toast.success("Max (20× credits) checkout is a placeholder.")}
          >
            Enable Max
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
